import type { IconData } from '@stacksjs/iconify-core'

export const hand: IconData = {
  "body": "<path fill=\"currentColor\" d=\"M28.185 7.62h1.53v12.19h-1.53Zm-1.52 12.19h1.52v4.57h-1.52Zm-1.52 7.62h-13.72v-3.05H9.9v3.05H8.375V32h19.81v-4.57h-1.52v-3.05h-1.52Zm0 3.05H22.1v-1.53h3.05Zm-1.53-16.77h1.53V7.62h3.04V6.1h-3.04V4.57h-1.53z\"/><path fill=\"currentColor\" d=\"M19.045 13.71h1.52V4.57h3.05V3.05h-3.05V1.52h-1.52zm-1.52 4.58h1.52v3.04h-1.52ZM15.995 0h3.05v1.52h-3.05Zm0 16.76h1.53v1.53h-1.53Zm-1.52-3.05h1.52V1.52h-4.57v1.53h3.05zm-3.05 1.53h4.57v1.52h-4.57Zm-3.05 6.09h1.53v3.05h-1.53Z\"/><path fill=\"currentColor\" d=\"M11.425 15.24V3.05h-1.52v10.66h-1.53v1.53zm-4.57 4.57h1.52v1.52h-1.52Zm0-7.62h1.52v1.52h-1.52Zm-1.52 6.1h1.52v1.52h-1.52Zm-1.53-7.62h3.05v1.52h-3.05Zm0 6.09h1.53v1.53h-1.53Zm-1.52-4.57h1.52v4.57h-1.52Z\"/>",
  "width": 32,
  "height": 32,
  "viewBox": "0 0 32 32"
}

export default hand
